export enum SortDirection {
	DESC = 'Descending',
	ASC = 'Ascending'
}

export interface SortingParams {
	field: string
	order: SortDirection
}
